import { useMemo } from "react";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";

const useStyle = () => {
  const { theme, primaryColor } = useGomakeTheme();
  const classes = useMemo(() => {
    return {
      ticketStyle: {
        display: "flex",
        width: "192px",
        height: "40px",
        alignItems: "center",
        boxShadow: "none",
        borderRadius: "var(--theme-radius-md, 4px)",
      },
      ticketStyleCompact: {
        flex: "0 0 auto",
        width: "150px",
        minWidth: "150px",
        height: "34px",
      },
      ticketContentStyle: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "0px 10px",
        alignItems: "center",
      },
      ticketContentStyleCompact: {
        padding: "0px 8px",
        gap: "6px",
      },
      numberStyle: {
        ...FONT_FAMILY.Lexend(500, 24),
        lineHeight: "30px",
        //  width:"min-content"
      },
      numberStyleCompact: {
        ...FONT_FAMILY.Lexend(500, 15),
        lineHeight: "18px",
        whiteSpace: "nowrap",
      },
      textStyle: {
        ...FONT_FAMILY.Lexend(400, 14),
        lineHeight: "17.5px",
        display: "flex",
        width: "100%",
        gap: "5px",
        alignItems: "center",
      },
      textStyleCompact: {
        ...FONT_FAMILY.Lexend(400, 12),
        lineHeight: "15px",
        gap: "4px",
        minWidth: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "& svg": {
          fontSize: "15px",
          width: "15px",
          height: "15px",
          flexShrink: 0,
        },
      },
      /** Mobile: one scrollable row instead of stacked full-width cards. */
      statisticsScroller: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: "6px",
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: "4px",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": { height: "4px" },
        "&::-webkit-scrollbar-thumb": {
          background: "#CCCDCF",
          borderRadius: "4px",
        },
      },
      verticalLine: {
        borderLeft: "1px solid #000",
        height: "20px",
        margin: "0 5px",
      },
      numStyle: {
        ...FONT_FAMILY.Inter(600, 15),
        lineHeight: "20px",
      },
      ticketContent: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "0px",
        alignItems: "center",
        gap: "8px",
      },
      totalTextStyle: {
        ...FONT_FAMILY.Lexend(600, 14),
        lineHeight: "20px",
        display: "flex",
        width: "100%",
        gap: "8px",
        alignItems: "center",
      },
      cardStyle: {
        display: "inline-flex",
        padding: "12px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "8px",
        background: primaryColor(500),
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        height: "40px",
      },
      cardContainerStyle: {
        display: "inline-flex",
        padding: "12px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "8px",
        background: primaryColor(500),
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        height: "40px",
      },
    };
  }, [theme]);
  return {
    classes,
  };
};
export { useStyle };
